import React from 'react';


export function FieldLabel({ children }: { children: React.ReactNode }) {
    return <span className="text-sm font-montserrat font-medium text-slate-300">{children}</span>;
}